import { ThemeConfig } from 'antd';

// Default theme configuration
export const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: '#292d33',
    borderRadius: 6,
    colorIcon: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f0f2f5',
    colorTextBase: '#000000',
    fontSize: 12,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
  },
  components: {
    Button: {
      borderRadius: 4,
      controlHeight: 30,
    },
    Card: {
      borderRadius: 6,
    },
    Table: {
      borderRadius: 6,
    },
    Layout: {
      bodyBg: '#f0f2f5',
      headerBg: '#ffffff',
      siderBg: '#ffffff',
      colorBgBody: '#f0f2f5'
    }
  },
};

// Dark theme configuration
export const darkTheme: ThemeConfig = {
  token: {
    colorPrimary: '#292d33',
    colorIcon: '#ffffff',
    borderRadius: 6,
    colorBgContainer: '#141414',
    colorBgLayout: '#000000',
    colorTextBase: '#ffffff',
    fontSize: 12,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
  },
  components: {
    Button: {
      borderRadius: 4,
      controlHeight: 30,
    },
    Card: {
      borderRadius: 6,
    },
    Table: {
      borderRadius: 6,
    },
    Layout: {
      bodyBg: '#000000',
      headerBg: '#141414',
      siderBg: '#141414',
      colorBgBody: '#000000'
    }
  },
};
